(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fhbb-business-page"]) return;
  try {
    
if (!customElements.get('fhbb-business-page')) {
  customElements.define('fhbb-business-page', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const source = new URL(location.href).searchParams.get('business_entry');
      const entry = ['home','catalog','resources'].includes(source) ? source : 'direct';
      const entryInput = this.querySelector('[data-business-entry]');
      if (entryInput) entryInput.value = entry;
      const report = (event, extra = {}) => {
        if (this.dataset.reporting !== 'true' || this.hasAttribute('data-editor')) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event, business_entry:entry, ...extra});
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-business-action]');
        if (!link) return;
        const type = this.querySelector('[data-business-type]');
        if (type && link.dataset.businessNeed && !type.value) type.value = link.dataset.businessNeed;
        report('fhbb_business_path_selected', {business_path:link.dataset.businessAction, business_category:link.dataset.businessCategory || ''});
      }, options);
      const form = this.querySelector('form');
      form?.addEventListener('submit', () => {
        if (this.dataset.reporting !== 'true' || this.hasAttribute('data-editor')) return;
        try { sessionStorage.setItem('fhbb-business-pending', JSON.stringify({entry,at:Date.now()})); } catch {}
      }, options);
      if (this.querySelector('[data-business-success]')) {
        try {
          const pending = JSON.parse(sessionStorage.getItem('fhbb-business-pending') || 'null');
          if (pending && Date.now() - pending.at < 3600000) {
            sessionStorage.removeItem('fhbb-business-pending');
            report('fhbb_business_inquiry_submitted', {business_entry:pending.entry});
          }
        } catch {}
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-catalog-navigation"]) return;
  try {
    
if (!customElements.get('fhbb-catalog-navigation')) {
  customElements.define('fhbb-catalog-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const close = () => this.querySelectorAll('details[open]').forEach(item => { item.open = false; });
      this.querySelectorAll('details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open) this.querySelectorAll('details').forEach(other => { if (other !== item) other.open = false; });
      }, options));
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const item = event.target.closest('details[open]');
          if (item) { item.open = false; item.querySelector('summary').focus(); }
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-guided-header"]) return;
  try {
    
if (!customElements.get('fhbb-guided-navigation')) {
  customElements.define('fhbb-guided-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.setAttribute('data-enhanced', '');
      const section = this.closest('.shopify-section');
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', `${section.getBoundingClientRect().height}px`);
      });
      this.resizeObserver.observe(section);
      const button = this.querySelector('[data-menu-toggle]');
      const close = () => { this.removeAttribute('data-open'); button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        const open = !this.hasAttribute('data-open');
        this.toggleAttribute('data-open', open);
        button.setAttribute('aria-expanded', String(open));
      }, options);
      this.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) this.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (details) { details.open = false; details.querySelector('summary').focus(); }
        else if (this.hasAttribute('data-open')) { close(); button.focus(); }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a')) { close(); this.querySelectorAll('details[open]').forEach(item => { item.open = false; }); }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) { close(); this.querySelectorAll('details[open]').forEach(item => { item.open = false; }); }
      }, options);
      matchMedia('(min-width: 981px)').addEventListener('change', close, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-qf-asc"] && !Shopify.designMode) return;
  try {
    
function initializeFhbbAscQuote() {
  document.querySelectorAll('[data-fhbb-asc]').forEach(function(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = root.querySelector('form');
    if (!form) return;
    var prefix = 'fhbbAscQuote:v1:';
    var fields = root.querySelector('[data-asc-fields]');
    var success = root.querySelector('[data-asc-success]');
    var submit = root.querySelector('[data-asc-submit]');
    var submitLabel = submit.textContent;
    var inputs = Array.from(form.querySelectorAll('input:not([type="hidden"]), select'));
    var params = new URLSearchParams(location.search);
    var storage = {
      get: function(key) { try { return JSON.parse(sessionStorage.getItem(prefix + key) || 'null'); } catch (_) { return null; } },
      set: function(key,value) { try { sessionStorage.setItem(prefix + key,JSON.stringify(value)); return true; } catch (_) { return false; } },
      remove: function(key) { try { sessionStorage.removeItem(prefix + key); return true; } catch (_) { return false; } }
    };
    var emit = function(event, extra) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, quote_path: 'asc_inline', supplier: 'ASC', coverage_status: 'pending_review' },extra || {}));
      root.dataset.lastQuoteEvent = event;
    };
    var fresh = function(item) { return item && typeof item.at === 'number' && Date.now() - item.at < 30 * 60 * 1000 && Date.now() >= item.at; };
    var accepted = root.querySelector('[data-native-accepted]').dataset.nativeAccepted === 'true';
    var pending = storage.get('pending');
    var receipt = storage.get('receipt');
    var draft = storage.get('draft');
    var setStyle = function(code, title) {
      form.querySelector('[data-style-value]').value = code || '';
      var note=root.querySelector('[data-style-note]');
      note.hidden=!title;
      note.querySelector('span').textContent=title || '';
    };
    if (accepted && fresh(pending) && !root.querySelector('[data-asc-errors]')) {
      var consumed = storage.remove('pending');
      storage.remove('draft');
      receipt = {id:pending.id, at:Date.now(), test:pending.test};
      storage.set('receipt',receipt);
      if (consumed) emit('fhbb_building_quote_submitted',{event_id:pending.id,test_request:pending.test});
    } else if (!accepted) {
      storage.remove('pending');
      receipt=null;
      storage.remove('receipt');
    }
    var showSuccess=accepted;
    success.hidden=!showSuccess;
    fields.hidden=showSuccess;
    if(showSuccess) {
      inputs.forEach(function(input){input.disabled=true;});
      root.dataset.quoteAccepted='true';
      success.focus({preventScroll:true});
    } else if (fresh(draft)) {
      inputs.forEach(function(input){if(Object.hasOwn(draft.values,input.name)) input.value=draft.values[input.name];});
      setStyle(draft.style,draft.styleTitle);
    }
    var knownStyles={"ASC-CARPORT":"Open carport","ASC-GARAGE":"Metal garage","ASC-BARN":"Agricultural barn"};
    var styleParam=params.get('style');
    if (!showSuccess && styleParam && /^ASC-[A-Z0-9-]{1,40}$/.test(styleParam)) {
      setStyle(styleParam,(knownStyles[styleParam] ? knownStyles[styleParam]+' — ' : '')+styleParam);
    }
    if (!showSuccess && params.get('zip') && /^\d{5}(-\d{4})?$/.test(params.get('zip'))) form.querySelector('[data-asc-zip]').value=params.get('zip');
    var saveDraft=function() {
      var values={};
      inputs.forEach(function(input){values[input.name]=input.value;});
      storage.set('draft',{at:Date.now(),values:values,style:form.querySelector('[data-style-value]').value,styleTitle:root.querySelector('[data-style-note] span').textContent});
    };
    var started=false;
    var onChange=function() {
      if(!started) {started=true;emit('quote_form_started');}
      saveDraft();
    };
    form.addEventListener('input',onChange);
    form.addEventListener('change',onChange);
    var zip=form.querySelector('[data-asc-zip]');
    var validateZip=function() {
      zip.setCustomValidity(zip.value && !/^\d{5}(-\d{4})?$/.test(zip.value) ? root.dataset.zipError : '');
    };
    zip.addEventListener('input',validateZip);
    validateZip();
    root.querySelectorAll('[data-asc-style]').forEach(function(link){
      link.addEventListener('click',function(){
        if (showSuccess) return;
        setStyle(link.dataset.ascStyle,link.dataset.styleTitle+' — '+link.dataset.ascStyle);
        var styleUrl=new URL(location.href);
        styleUrl.searchParams.set('style',link.dataset.ascStyle);
        styleUrl.hash='asc-quote';
        history.replaceState(null,'',styleUrl.href);
        var type=form.querySelector('select');
        if(!type.value) type.value=link.dataset.ascStyle==='ASC-BARN'?'Barn / agricultural':link.dataset.ascStyle==='ASC-CARPORT'?'Carport / RV cover':'Garage / workshop';
        saveDraft();
      });
    });
    document.querySelectorAll('a[href="#asc-quote"]').forEach(function(link){
      link.addEventListener('click',function(){requestAnimationFrame(function(){root.querySelector('#asc-quote').focus({preventScroll:true});});});
    });
    root.querySelectorAll('[data-asc-builder]').forEach(function(link){link.addEventListener('click',function(){emit('asc_builder_open');});});
    var entrySource=(params.get('source') || '').slice(0,100).replace(/[\r\n]/g,' ');
    form.querySelector('[data-entry-source]').value=entrySource;
    var attribution={};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid'].forEach(function(key){
      var value=params.get(key);
      if(value) attribution[key]=value.slice(0,250);
    });
    form.querySelector('[data-attribution]').value=JSON.stringify(attribution);
    var timeout;
    form.addEventListener('submit',function(event){
      if(showSuccess || form.dataset.submitting==='true') {event.preventDefault();return;}
      validateZip();
      if(!form.checkValidity()) {event.preventDefault();form.reportValidity();return;}
      var id=window.crypto && crypto.randomUUID?crypto.randomUUID():Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
      var name=form.querySelector('input[name="contact[name]"]').value;
      var isTest=params.get('fhbb_test')==='1' || /^TEST FHBB\b/i.test(name);
      form.querySelector('[data-request-reference]').value=id;
      var lines=[isTest?'TEST FHBB ASC QUOTE — EXCLUDE FROM BUSINESS REPORTING':'FHBB ASC QUOTE REQUEST','Source: /pages/american-steel-carports','Request reference: '+id,'Coverage: pending review. Not yet qualified.'];
      inputs.forEach(function(input){lines.push(input.name.replace(/^contact\[|\]$/g,'')+': '+(input.value||'Not provided'));});
      if(form.querySelector('[data-style-value]').value) lines.push('Starting style: '+form.querySelector('[data-style-value]').value);
      if(entrySource) lines.push('Entry source: '+entrySource);
      lines.push('Campaign attribution: '+JSON.stringify(attribution));
      form.querySelector('[data-asc-body]').value=lines.join('\n');
      saveDraft();
      storage.set('pending',{id:id,at:Date.now(),test:isTest});
      form.dataset.submitting='true';
      submit.disabled=true;
      submit.textContent=root.dataset.sending;
      timeout=setTimeout(function(){
        root.querySelector('[data-asc-retry]').hidden=false;
        submit.disabled=false;
        submit.textContent=submitLabel;
        form.dataset.submitting='false';
      },20000);
    });
    window.addEventListener('pageshow',function(event){
      if(event.persisted) {
        clearTimeout(timeout);
        var saved=storage.get('receipt');
        if(accepted && fresh(saved)) {
          success.hidden=false;fields.hidden=true;showSuccess=true;
          inputs.forEach(function(input){input.disabled=true;});
        } else {
          form.dataset.submitting='false';submit.disabled=false;submit.textContent=submitLabel;
          if(storage.get('pending')) root.querySelector('[data-asc-retry]').hidden=false;
        }
      }
    });
  });
}
initializeFhbbAscQuote();
document.addEventListener('shopify:section:load',initializeFhbbAscQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-qf-coverage"] && !Shopify.designMode) return;
  try {
    
function normalizeFhbbZip(raw) {
  const text = String(raw || '').trim();
  if (!/^\d{5}(-\d{4})?$/.test(text) || text.slice(0,5) === '00000') return null;
  return text.slice(0,5);
}
function resolveFhbbZip(raw, rules, today = new Date()) {
  const zip = normalizeFhbbZip(raw);
  if (!zip) return {status:'invalid',zip:null,suppliers:[]};
  if (/^99[5-9]/.test(zip) || (/^96[78]/.test(zip) && !['96799','96898'].includes(zip))) return {status:'no-service',zip,suppliers:[]};
  const current = rules.filter(rule => rule.zip === zip && rule.confirmed === true && typeof rule.source === 'string' && rule.source.trim() && Number.isFinite(Date.parse(rule.expires_at)) && Date.parse(rule.expires_at) >= today.getTime());
  const supported = current.filter(rule => rule.status === 'supported' && ['UMB','Safeguard','SBSI'].includes(rule.supplier));
  const unsupported = current.some(rule => rule.status === 'unsupported' && rule.scope === 'all-custom');
  if (supported.length && !unsupported) return {status:'supported',zip,suppliers:[...new Set(supported.map(rule => rule.supplier))]};
  if (unsupported && !supported.length) return {status:'unsupported',zip,suppliers:[]};
  return {status:'uncertain',zip,suppliers:[]};
}
function initializeFhbbCoverage() {
  document.querySelectorAll('[data-fhbb-coverage]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const rules = JSON.parse(root.querySelector('[data-coverage-rules]').textContent);
    const messages = JSON.parse(root.querySelector('[data-coverage-messages]').textContent);
    const form = root.querySelector('[data-zip-form]');
    const input = root.querySelector('[data-zip-input]');
    const select = root.querySelector('[data-state-select]');
    const heading = root.querySelector('[data-result-heading]');
    const copy = root.querySelector('[data-result-copy]');
    const quote = root.querySelector('[data-quote-link]');
    const umb = root.querySelector('[data-umb-link]');
    const tiles = [...root.querySelectorAll('[data-state]')];
    const quoteUrl = (zip, supplier) => {
      const url = new URL(supplier === 'UMB' ? '/pages/united-metal-buildings#umb-quote' : root.dataset.quoteUrl, location.origin);
      if (supplier !== 'UMB') url.searchParams.set('path','help');
      if (zip) url.searchParams.set('zip',zip);
      if (select.value) url.searchParams.set('state',select.value);
      if (supplier) url.searchParams.set('supplier',supplier);
      url.searchParams.set('source','coverage-check');
      return url.href;
    };
    const showNoService = () => {
      root.dataset.coverageStatus = 'no-service';
      heading.textContent = messages.noServiceHeading;
      copy.textContent = messages.noService;
      quote.hidden = true;
      umb.hidden = true;
    };
    const showState = code => {
      const tile = tiles.find(item => item.dataset.state === code);
      tiles.forEach(item => item.setAttribute('aria-pressed',String(item === tile)));
      select.value = tile ? code : '';
      const supplier = tile?.dataset.supplierHint || '';
      heading.textContent = tile ? [tile.dataset.stateName,supplier,tile.dataset.partial === 'true' ? messages.partial : messages.pending].filter(Boolean).join(' — ') : messages.pending;
      if (resolveFhbbZip(input.value,rules).status === 'no-service') { showNoService(); return; }
      copy.textContent = messages.state;
      quote.href = quoteUrl(normalizeFhbbZip(input.value),supplier);
      quote.hidden = false;
      umb.hidden = supplier !== 'UMB';
      root.dataset.coverageStatus = 'uncertain';
    };
    tiles.forEach(tile => tile.addEventListener('click',() => showState(tile.dataset.state)));
    select.addEventListener('change',() => showState(select.value));
    input.addEventListener('input',() => {input.setCustomValidity('');input.removeAttribute('aria-invalid');});
    input.addEventListener('invalid',() => {
      input.setAttribute('aria-invalid','true');
      root.dataset.coverageStatus = 'invalid';
      heading.textContent = messages.invalidHeading;
      copy.textContent = messages.invalid;
      quote.hidden = true;
      umb.hidden = true;
    });
    form.addEventListener('submit',event => {
      event.preventDefault();
      const result = resolveFhbbZip(input.value,rules);
      root.dataset.coverageStatus = result.status;
      if (result.status === 'invalid') {
        input.setAttribute('aria-invalid','true');
        heading.textContent = messages.invalidHeading;
        copy.textContent = messages.invalid;
        quote.hidden = true;
        umb.hidden = true;
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      if (result.status === 'no-service') { showNoService(); return; }
      const tile = tiles.find(item => item.dataset.state === select.value);
      const supplier = result.suppliers.join(', ') || tile?.dataset.supplierHint || '';
      heading.textContent = result.zip + ' — ' + (result.status === 'unsupported' ? messages.unsupportedHeading : result.status === 'supported' ? messages.validHeading : messages.pending);
      copy.textContent = messages[result.status];
      quote.hidden = false;
      quote.href = quoteUrl(result.zip,supplier);
      umb.hidden = result.status === 'unsupported' || !(result.status === 'supported' ? result.suppliers.includes('UMB') : tile?.dataset.supplierHint === 'UMB');
      root.querySelector('[data-coverage-result]').scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  });
}
initializeFhbbCoverage();
document.addEventListener('shopify:section:load',initializeFhbbCoverage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-qf-supplier"] && !Shopify.designMode) return;
  try {
    
function initializeFhbbSupplierQuote() {
  document.querySelectorAll('[data-fhbb-supplier]').forEach(function(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = root.querySelector('form');
    if (!form) return;
    var supplierKey=root.dataset.supplierKey;
    var quoteAnchor=root.dataset.quoteAnchor;
    var canonicalPath=root.dataset.canonicalPath;
    var prefix = 'fhbbSupplierQuote:v1:'+supplierKey+':';
    var fields = root.querySelector('[data-supplier-fields]');
    var success = root.querySelector('[data-supplier-success]');
    var submit = root.querySelector('[data-supplier-submit]');
    var submitLabel = submit.textContent;
    var inputs = Array.from(form.querySelectorAll('input:not([type="hidden"]), select'));
    var params = new URLSearchParams(location.search);
    var storage = {
      get: function(key) { try { return JSON.parse(sessionStorage.getItem(prefix + key) || 'null'); } catch (_) { return null; } },
      set: function(key,value) { try { sessionStorage.setItem(prefix + key,JSON.stringify(value)); return true; } catch (_) { return false; } },
      remove: function(key) { try { sessionStorage.removeItem(prefix + key); return true; } catch (_) { return false; } }
    };
    var emit = function(event, extra) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, quote_path: root.dataset.quotePath, supplier: supplierKey, coverage_status: 'pending_review' },extra || {}));
      root.dataset.lastQuoteEvent = event;
    };
    var fresh = function(item) { return item && typeof item.at === 'number' && Date.now() - item.at < 30 * 60 * 1000 && Date.now() >= item.at; };
    var accepted = root.querySelector('[data-native-accepted]').dataset.nativeAccepted === 'true';
    var pending = storage.get('pending');
    var receipt = storage.get('receipt');
    var draft = storage.get('draft');
    var setStyle = function(code, title) {
      form.querySelector('[data-style-value]').value = code || '';
      var note=root.querySelector('[data-style-note]');
      note.hidden=!title;
      note.querySelector('span').textContent=title || '';
    };
    if (accepted && fresh(pending) && !root.querySelector('[data-supplier-errors]')) {
      var consumed = storage.remove('pending');
      storage.remove('draft');
      receipt = {id:pending.id, at:Date.now(), test:pending.test};
      storage.set('receipt',receipt);
      if (consumed) emit('fhbb_building_quote_submitted',{event_id:pending.id,test_request:pending.test});
    } else if (!accepted) {
      storage.remove('pending');
      receipt=null;
      storage.remove('receipt');
    }
    var showSuccess=accepted;
    success.hidden=!showSuccess;
    fields.hidden=showSuccess;
    root.querySelector('[data-test-notice]').hidden=!(showSuccess && receipt && receipt.test);
    if(showSuccess) {
      inputs.forEach(function(input){input.disabled=true;});
      root.dataset.quoteAccepted='true';
      success.focus({preventScroll:true});
    } else if (fresh(draft)) {
      inputs.forEach(function(input){if(Object.hasOwn(draft.values,input.name)) input.value=draft.values[input.name];});
      setStyle(draft.style,draft.styleTitle);
    }
    var knownStyles=JSON.parse(root.querySelector('[data-known-styles]').textContent);
    var styleParam=params.get('style');
    if (!showSuccess && styleParam && Object.hasOwn(knownStyles,styleParam)) {
      setStyle(styleParam,knownStyles[styleParam].title+' — '+styleParam);
      if(!form.querySelector('select').value) form.querySelector('select').value=knownStyles[styleParam].type;
    }
    if (!showSuccess && params.get('zip') && /^\d{5}(-\d{4})?$/.test(params.get('zip'))) form.querySelector('[data-supplier-zip]').value=params.get('zip');
    var saveDraft=function() {
      var values={};
      inputs.forEach(function(input){values[input.name]=input.value;});
      storage.set('draft',{at:Date.now(),values:values,style:form.querySelector('[data-style-value]').value,styleTitle:root.querySelector('[data-style-note] span').textContent});
    };
    var started=false;
    var onChange=function() {
      if(!started) {started=true;emit('quote_form_started');}
      saveDraft();
    };
    form.addEventListener('input',onChange);
    form.addEventListener('change',onChange);
    var zip=form.querySelector('[data-supplier-zip]');
    var validateZip=function() {
      zip.setCustomValidity(zip.value && !/^\d{5}(-\d{4})?$/.test(zip.value) ? root.dataset.zipError : '');
    };
    zip.addEventListener('input',validateZip);
    validateZip();
    root.querySelectorAll('[data-supplier-style]').forEach(function(link){
      link.addEventListener('click',function(){
        if (showSuccess) return;
        setStyle(link.dataset.supplierStyle,link.dataset.styleTitle+' — '+link.dataset.supplierStyle);
        var styleUrl=new URL(location.href);
        styleUrl.searchParams.set('style',link.dataset.supplierStyle);
        styleUrl.hash=quoteAnchor;
        history.replaceState(null,'',styleUrl.href);
        var type=form.querySelector('select');
        if(!type.value && knownStyles[link.dataset.supplierStyle]) type.value=knownStyles[link.dataset.supplierStyle].type;
        saveDraft();
      });
    });
    document.querySelectorAll('a[href="#'+quoteAnchor+'"]').forEach(function(link){
      link.addEventListener('click',function(){requestAnimationFrame(function(){root.querySelector('#'+quoteAnchor).focus({preventScroll:true});});});
    });
    var entrySource=/^[a-z0-9][a-z0-9_-]{0,99}$/i.test(params.get('source')||'') ? params.get('source') : '';
    var promotion='';
    form.querySelector('[data-entry-source]').value=entrySource;
    form.querySelector('[data-promotion]').value=promotion;
    var attribution={};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid'].forEach(function(key){
      var value=params.get(key);
      if(value) attribution[key]=value.slice(0,250);
    });
    form.querySelector('[data-attribution]').value=JSON.stringify(attribution);
    var timeout;
    form.addEventListener('submit',function(event){
      if(showSuccess || form.dataset.submitting==='true') {event.preventDefault();return;}
      validateZip();
      if(!form.checkValidity()) {event.preventDefault();form.reportValidity();return;}
      var id=window.crypto && crypto.randomUUID?crypto.randomUUID():Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
      var name=form.querySelector('input[name="contact[name]"]').value;
      var isTest=params.get('fhbb_test')==='1' || /^TEST FHBB\b/i.test(name);
      form.querySelector('[data-request-reference]').value=id;
      var lines=[isTest?'TEST FHBB '+supplierKey+' QUOTE — EXCLUDE FROM BUSINESS REPORTING':'FHBB '+supplierKey+' QUOTE REQUEST','Supplier: '+supplierKey,'Source: '+canonicalPath,'Request reference: '+id,'Coverage: pending review. Not yet qualified.'];
      inputs.forEach(function(input){lines.push(input.name.replace(/^contact\[|\]$/g,'')+': '+(input.value||'Not provided'));});
      if(form.querySelector('[data-style-value]').value) lines.push('Starting style: '+form.querySelector('[data-style-value]').value);
      if(entrySource) lines.push('Entry source: '+entrySource);
      if(promotion) lines.push('Promotion reference: '+promotion);
      lines.push('Campaign attribution: '+JSON.stringify(attribution));
      form.querySelector('[data-supplier-body]').value=lines.join('\n');
      saveDraft();
      storage.set('pending',{id:id,at:Date.now(),test:isTest});
      form.dataset.submitting='true';
      submit.disabled=true;
      submit.textContent=root.dataset.sending;
      timeout=setTimeout(function(){
        root.querySelector('[data-supplier-retry]').hidden=false;
        submit.disabled=false;
        submit.textContent=submitLabel;
        form.dataset.submitting='false';
      },20000);
    });
    window.addEventListener('pageshow',function(event){
      if(event.persisted) {
        clearTimeout(timeout);
        var saved=storage.get('receipt');
        if(accepted && fresh(saved)) {
          success.hidden=false;fields.hidden=true;showSuccess=true;
          inputs.forEach(function(input){input.disabled=true;});
        } else {
          form.dataset.submitting='false';submit.disabled=false;submit.textContent=submitLabel;
          if(storage.get('pending')) root.querySelector('[data-supplier-retry]').hidden=false;
        }
      }
    });
  });
}
initializeFhbbSupplierQuote();
document.addEventListener('shopify:section:load',initializeFhbbSupplierQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-qf-umb"] && !Shopify.designMode) return;
  try {
    
var fhbbLegacyDesigner=document.querySelector('[data-umb-legacy-designer]');
if(fhbbLegacyDesigner) window.location.replace(fhbbLegacyDesigner.href);
function initializeFhbbUmbQuote() {
  document.querySelectorAll('[data-fhbb-umb]').forEach(function(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var form = root.querySelector('form');
    if (!form) return;
    var prefix = 'fhbbUmbQuote:v1:';
    var fields = root.querySelector('[data-umb-fields]');
    var success = root.querySelector('[data-umb-success]');
    var submit = root.querySelector('[data-umb-submit]');
    var submitLabel = submit.textContent;
    var inputs = Array.from(form.querySelectorAll('input:not([type="hidden"]), select'));
    var params = new URLSearchParams(location.search);
    var storage = {
      get: function(key) { try { return JSON.parse(sessionStorage.getItem(prefix + key) || 'null'); } catch (_) { return null; } },
      set: function(key,value) { try { sessionStorage.setItem(prefix + key,JSON.stringify(value)); return true; } catch (_) { return false; } },
      remove: function(key) { try { sessionStorage.removeItem(prefix + key); return true; } catch (_) { return false; } }
    };
    var emit = function(event, extra) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, quote_path: 'umb_inline', supplier: 'UMB', coverage_status: 'pending_review' },extra || {}));
      root.dataset.lastQuoteEvent = event;
    };
    var fresh = function(item) { return item && typeof item.at === 'number' && Date.now() - item.at < 30 * 60 * 1000 && Date.now() >= item.at; };
    var accepted = root.querySelector('[data-native-accepted]').dataset.nativeAccepted === 'true';
    var pending = storage.get('pending');
    var receipt = storage.get('receipt');
    var draft = storage.get('draft');
    var setStyle = function(code, title) {
      form.querySelector('[data-style-value]').value = code || '';
      var note=root.querySelector('[data-style-note]');
      note.hidden=!title;
      note.querySelector('span').textContent=title || '';
    };
    if (accepted && fresh(pending) && !root.querySelector('[data-umb-errors]')) {
      var consumed = storage.remove('pending');
      storage.remove('draft');
      receipt = {id:pending.id, at:Date.now(), test:pending.test};
      storage.set('receipt',receipt);
      if (consumed) emit('fhbb_building_quote_submitted',{event_id:pending.id,test_request:pending.test});
    } else if (!accepted) {
      storage.remove('pending');
      receipt=null;
      storage.remove('receipt');
    }
    var showSuccess=accepted;
    success.hidden=!showSuccess;
    fields.hidden=showSuccess;
    root.querySelector('[data-test-notice]').hidden=!(showSuccess && receipt && receipt.test);
    if(showSuccess) {
      inputs.forEach(function(input){input.disabled=true;});
      root.dataset.quoteAccepted='true';
      success.focus({preventScroll:true});
    } else if (fresh(draft)) {
      inputs.forEach(function(input){if(Object.hasOwn(draft.values,input.name)) input.value=draft.values[input.name];});
      setStyle(draft.style,draft.styleTitle);
    }
    var knownStyles={"UMB-011":"Side-entry garage","UMB-004":"Open-front animal shelter","UMB-005":"Longer animal shelter","UMB-010":"Two-car garage example","UMB-012":"Garage with windows","UMB-002":"Agricultural building","UMB-003":"Agricultural building with tall access","UMB-AG-001":"Agricultural storage building"};
    var styleParam=params.get('style');
    if (!showSuccess && styleParam && /^UMB-[A-Z0-9-]{1,40}$/.test(styleParam)) {
      setStyle(styleParam,(knownStyles[styleParam] ? knownStyles[styleParam]+' — ' : '')+styleParam);
    }
    if (!showSuccess && params.get('zip') && /^\d{5}(-\d{4})?$/.test(params.get('zip'))) form.querySelector('[data-umb-zip]').value=params.get('zip');
    var saveDraft=function() {
      var values={};
      inputs.forEach(function(input){values[input.name]=input.value;});
      storage.set('draft',{at:Date.now(),values:values,style:form.querySelector('[data-style-value]').value,styleTitle:root.querySelector('[data-style-note] span').textContent});
    };
    var started=false;
    var onChange=function() {
      if(!started) {started=true;emit('quote_form_started');}
      saveDraft();
    };
    form.addEventListener('input',onChange);
    form.addEventListener('change',onChange);
    var zip=form.querySelector('[data-umb-zip]');
    var validateZip=function() {
      zip.setCustomValidity(zip.value && !/^\d{5}(-\d{4})?$/.test(zip.value) ? root.dataset.zipError : '');
    };
    zip.addEventListener('input',validateZip);
    validateZip();
    root.querySelectorAll('[data-umb-style]').forEach(function(link){
      link.addEventListener('click',function(){
        if (showSuccess) return;
        setStyle(link.dataset.umbStyle,link.dataset.styleTitle+' — '+link.dataset.umbStyle);
        var styleUrl=new URL(location.href);
        styleUrl.searchParams.set('style',link.dataset.umbStyle);
        styleUrl.hash='umb-quote';
        history.replaceState(null,'',styleUrl.href);
        var type=form.querySelector('select');
        if(!type.value) type.value=link.dataset.umbStyle==='UMB-AG-001'?'Barn / agricultural':'Garage / workshop';
        saveDraft();
      });
    });
    document.querySelectorAll('a[href="#umb-quote"]').forEach(function(link){
      link.addEventListener('click',function(){requestAnimationFrame(function(){root.querySelector('#umb-quote').focus({preventScroll:true});});});
    });
    root.querySelectorAll('[data-umb-builder]').forEach(function(link){link.addEventListener('click',function(){emit('umb_builder_open');});});
    var entrySource=(params.get('source') || '').slice(0,100).replace(/[\r\n]/g,' ');
    var promotion=(params.get('promotion') || '').slice(0,100).replace(/[\r\n]/g,' ');
    var retiredPromotion=promotion.toLowerCase()==='umb-labor-day-2026';
    form.querySelector('[data-entry-source]').value=entrySource;
    form.querySelector('[data-promotion]').value=retiredPromotion ? '' : promotion;
    var attribution={};
    if(retiredPromotion) {
      attribution.expired_promotion=promotion;
      attribution.promotion_status='expired - historical acquisition only; no current eligibility';
    }
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid'].forEach(function(key){
      var value=params.get(key);
      if(value) attribution[key]=value.slice(0,250);
    });
    form.querySelector('[data-attribution]').value=JSON.stringify(attribution);
    var timeout;
    form.addEventListener('submit',function(event){
      if(showSuccess || form.dataset.submitting==='true') {event.preventDefault();return;}
      validateZip();
      if(!form.checkValidity()) {event.preventDefault();form.reportValidity();return;}
      var id=window.crypto && crypto.randomUUID?crypto.randomUUID():Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
      var name=form.querySelector('input[name="contact[name]"]').value;
      var isTest=params.get('fhbb_test')==='1' || /^TEST FHBB\b/i.test(name);
      form.querySelector('[data-request-reference]').value=id;
      var lines=[isTest?'TEST FHBB UMB QUOTE — EXCLUDE FROM BUSINESS REPORTING':'FHBB UMB QUOTE REQUEST','Source: /pages/united-metal-buildings','Request reference: '+id,'Coverage: pending review. Not yet qualified.'];
      inputs.forEach(function(input){lines.push(input.name.replace(/^contact\[|\]$/g,'')+': '+(input.value||'Not provided'));});
      if(form.querySelector('[data-style-value]').value) lines.push('Starting style: '+form.querySelector('[data-style-value]').value);
      if(entrySource) lines.push('Entry source: '+entrySource);
      if(promotion && !retiredPromotion) lines.push('Promotion reference: '+promotion);
      lines.push('Campaign attribution: '+JSON.stringify(attribution));
      form.querySelector('[data-umb-body]').value=lines.join('\n');
      saveDraft();
      storage.set('pending',{id:id,at:Date.now(),test:isTest});
      form.dataset.submitting='true';
      submit.disabled=true;
      submit.textContent=root.dataset.sending;
      timeout=setTimeout(function(){
        root.querySelector('[data-umb-retry]').hidden=false;
        submit.disabled=false;
        submit.textContent=submitLabel;
        form.dataset.submitting='false';
      },20000);
    });
    window.addEventListener('pageshow',function(event){
      if(event.persisted) {
        clearTimeout(timeout);
        var saved=storage.get('receipt');
        if(accepted && fresh(saved)) {
          success.hidden=false;fields.hidden=true;showSuccess=true;
          inputs.forEach(function(input){input.disabled=true;});
        } else {
          form.dataset.submitting='false';submit.disabled=false;submit.textContent=submitLabel;
          if(storage.get('pending')) root.querySelector('[data-umb-retry]').hidden=false;
        }
      }
    });
  });
}
initializeFhbbUmbQuote();
document.addEventListener('shopify:section:load',initializeFhbbUmbQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fhbb-tarter-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fhbb-tarter-guide')) {
  customElements.define('fhbb-tarter-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const form = this.querySelector('form');
      const interest = this.querySelector('[data-tarter-interest]');
      const selected = this.querySelector('[data-tarter-selection]');
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-tarter-choice]');
        if (!choice || !interest || !selected) return;
        interest.value = choice.dataset.tarterChoice;
        selected.textContent = this.dataset.selectedLabel + ' ' + interest.value;
        selected.hidden = false;
        this.querySelector('#tarter-quote')?.focus({ preventScroll: true });
      }, options);
      if (!form || !interest) return;
      const params = new URLSearchParams(window.location.search);
      const attribution = {};
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','epik'].forEach(key => {
        const value = params.get(key);
        if (value) attribution[key] = value.slice(0,500);
      });
      form.querySelector('[data-tarter-attribution]').value = JSON.stringify(attribution);
      form.querySelector('[data-tarter-page]').value = window.location.origin + window.location.pathname;
      form.querySelector('[data-tarter-reference]').value = crypto.randomUUID();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
